export const GET_NEXTOFKIN_DETAILS = 'GET_NEXTOFKIN_DETAILS'
export const CLEAR_NEXTOFKIN_DETAILS = 'CLEAR_NEXTOFKIN_DETAILS'
